import { isolateComponent } from '@zapier/style-encapsulation';
import { BaseButton } from '../Button/BaseButton';
export const ButtonNavButton = (props) => {
    return isolateComponent(BaseButton, Object.assign({}, props, { size: "small" }));
};
//# sourceMappingURL=ButtonNavButton.js.map
// @zapier/design-system@6.14.1 (10126c41d)
